import type { FlexProps } from '@chakra-ui/react';
import {
  Box,
  Flex,
  HStack,
  Image,
  Link,
  Separator,
  Spacer,
  Stack,
  Text,
} from '@chakra-ui/react';
import SocialIcons from '@ui/components/Atoms/SocialIcons';
import { TERMS_AND_CONDITIONS_URL, WHITE_PAPER_URL } from '@ui/config/urls';
import { useTranslations } from 'next-intl';

export const Footer = (props: FlexProps) => {
  const t = useTranslations();

  return (
    <Flex
      w="full"
      h={{ base: 'auto', lg: '64px' }}
      pt={{ base: '48px', lg: '50px' }}
      pb={{ base: '16px', lg: '50px' }}
      px={{ base: 4, lg: '48px' }}
      position="relative"
      alignItems={{ base: 'start', md: 'center' }}
      direction={{ base: 'column', md: 'row' }}
      gap={5}
      fontFamily="footer"
      {...props}
    >
      <Stack
        direction={{ base: 'column', md: 'row' }}
        gap={{ base: 4, md: 8 }}
        align={{ base: 'start', md: 'center' }}
      >
        <Image
          src="/images/footer-icon.svg"
          alt="footer-icon"
          w={{ base: 28, lg: '100px' }}
        />
        <Box alignSelf="stretch" display={{ base: 'none', md: 'block' }}>
          <Separator
            my={1}
            size="md"
            borderColor="#B4B4B4"
            orientation="vertical"
          />
        </Box>

        <Flex gapX={{ base: 7, lg: 9 }} gapY={6} flexWrap="wrap">
          <HStack
            gapX={{ base: 7, lg: 9 }}
            textStyle={{ base: 'body1', lg: 'body1Emphasis' }}
          >
            <Link href={WHITE_PAPER_URL} target="_blank" color="#B4B4B4">
              {t('common.Whitepaper')}
            </Link>
            <Link
              href={TERMS_AND_CONDITIONS_URL}
              target="_blank"
              color="#B4B4B4"
            >
              {t('common.Terms and Conditions')}
            </Link>
            {/* <Link href="" target="_blnak" color="#B4B4B4">
                {t('common.Gitbook')}
              </Link> */}
          </HStack>
          <SocialIcons mode="footer" />
        </Flex>
      </Stack>
      <Spacer />
      <Text textStyle="caption1" color="#B4B4B4">
        Copyright (c) Capybara Nation. All rights reserved.
      </Text>
    </Flex>
  );
};
